export const easyWordsTR = [
  "kedi", "köpek", "ev", "su", "yol", "el", "kuş", "göz", "kol", "ay",
  "güneş", "ateş", "yağmur", "kar", "deniz", "göl", "dağ", "taş", "kum", "çay",
  "ekmek", "süt", "tuz", "bal", "et", "kek", "elma", "armut", "üzüm", "kiraz",
  "fındık", "ceviz", "biber", "soğan", "havuç", "domates", "salata",
  "masa", "kapı", "duvar", "cam", "perde", "halı", "yatak", "yastık",
  "kitap", "kalem", "defter", "silgi", "çanta", "okul", "sınıf",
  "araba", "tren", "uçak", "gemi", "otobüs", "kamyon", "taksi",
  "kırmızı", "mavi", "sarı", "yeşil", "mor", "pembe", "siyah", "beyaz", "gri",
  "büyük", "küçük", "uzun", "kısa", "geniş", "dar", "sıcak", "soğuk", "ılık",
  "anne", "baba", "abla", "kardeş", "amca", "teyze", "dede",
  "iyi", "kötü", "güzel", "çirkin", "hızlı", "yavaş", "akıllı", "tatlı", "acı",
  "saat", "gün", "hafta", "yıl", "sabah", "akşam", "gece",
];

export const mediumWordsTR = [
  "bilgisayar", "telefon", "televizyon", "internet", "anahtar", "pencere",
  "merdiven", "asansör", "bahçe", "balkon", "köprü", "tünel",
  "tiyatro", "sinema", "müzik", "resim", "heykel", "şarkı", "konser", "festival",
  "öğretmen", "doktor", "mühendis", "avukat", "hemşire", "polis", "asker",
  "futbol", "basketbol", "voleybol", "tenis", "yüzme", "dağcılık",
  "kahvaltı", "yemek", "pasta", "börek", "çorba", "köfte",
  "yağmurlu", "güneşli", "rüzgarlı", "karlı", "bulutlu", "sıcaklık", "soğukluk",
  "kütüphane", "müze", "üniversite", "ilkokul", "hastane", "eczane",
  "kelebek", "yunus", "papağan", "tavşan", "kaplumbağa", "yılan", "aslan",
  "yıldız", "gezegen", "uzay", "roket", "uydu", "gökyüzü", "yörünge",
  "gitarlı", "kemanlı", "davullu", "şarkıcı", "besteci", "yönetmen", "oyuncu",
  "bilgili", "düşünceli", "saygılı", "çalışkan", "tembel", "üzgün",
  "macera", "korkulu", "gizemli", "esrarengiz", "büyülü", "fantastik", "gerçek",
];

export const hardWordsTR = [
  "küreselleşme", "muhteşemlik", "telaffuz", "olağanüstü", "hayalgücü",
  "inanılmaz", "algılama", "devrim", "atmosfer", "felsefe", "mühendislik",
  "edebiyat", "perspektif", "anlamak", "deneyim", "değerlendirme", "iletişim",
  "kutlama", "navigasyon", "vakıf", "keşif", "ifade", "fenomen", "muhteşem",
  "muazzam", "başarı", "maceracı", "büyükelçi", "yıldönümü", "görünüş",
  "mimari", "aritmetik", "atmosferik", "sınırlar", "hesaplama", "karbonhidrat",
  "felaket", "şampiyonluk", "karakteristik", "medeniyet", "kombinasyon",
  "ticari", "şefkat", "yoğunlaşma", "yapılandırma", "bağlaç", "bilinçlilik",
  "korunma", "anayasa", "konsültasyon", "çağdaş", "tartışma", "kolaylık",
  "işbirliği", "şirket", "mektuplaşma", "eleştiri", "müfredat", "tanım",
  "gösterim", "departman", "betimleme", "kararlılık", "gelişim", "zorluk",
  "ayrımcılık", "dağıtım", "çeşitlilik", "belgesel", "ekonomik", "eğitim",
  "verimlilik", "elektrik", "ansiklopedi", "kuruluş", "çevre", "akademisyen",
  "demokrasi", "filozofik", "geometrik", "imparator", "konferans",
];

export const expertWordsTR = [
  "şanseseri", "özümseme", "kendineözgü", "alevlendirmek", "kavrayışlı",
  "yücegönüllü", "değişkenlik", "geçici", "heryerde", "kakofoni", "üstünkörü",
  "tartışılmaz", "şaşkınlık", "kibirli", "aydınlık", "dikbaşlı", "olağanüstügüzel",
  "uzunsözlü", "anakronik", "saçmasapan", "yorulmakbilmez", "rızagöstermek",
  "çeviklik", "iyileştirmek", "anakronizm", "antitez", "uydurma", "onaylama",
  "öğrenmek", "şüphecibakış", "çalışkanlık", "büzücülük", "cüretkar", "savaşkan",
  "tumturaklı", "bizansbenzeri", "huysuzluk", "kaprisli", "azarlamak", "eleştirel",
  "ihtiyatlı", "gizlikapaklı", "bilirkişilik", "orantılılık", "vicdanazabı",
  "eşlikeden", "yangın", "kanbağı", "küçümseyici", "neşelilik", "saflık",
  "hantallık", "zararlılık", "demagog", "yermek", "düzensizlik", "saydamlık",
  "öğretici", "çekingen", "yalansöylemek", "ikiyüzlülük", "neşeyledolu",
  "köpürmek", "berbatlık", "ağıtbenzeri", "aydınlatmak", "övmek",
  "güçtendüşürmek", "saklamak", "soğukkanlılık", "düzensizdüşünce",
  "uyumsuzluk", "umutsuzluk", "mütevazılık", "katılaşmak", "olağandışı",
];
